import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import VueCookies from 'vue-cookies'

document.addEventListener('DOMContentLoaded', function(/*event*/) {
  //the event occurred
  if (!document.getElementById("app")) return;
  window.isLoaded = true;
  initVue();
})

window.addEventListener('beforeunload', function(event) {
  console.log('I am the 1st one.', event);
  //store.dispatch('account/logout');
});
window.addEventListener('unload', function(event) {
  console.log('I am the 3rd one.', event);
  //store.dispatch('account/logout');
});

function initVue(){
  Vue.config.productionTip = false
  Vue.use(VueCookies)

  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')

  store.dispatch('booking/updateConfiguration');

  let lang = VueCookies.get('pll_language');
  if (lang) i18n.locale = lang;
}